import { Pipe, PipeTransform } from '@angular/core';
import { ChecklistItem } from '../modules/checklist/types/ChecklistTypes';

@Pipe({
  standalone: true,
  name: 'checklistItemOrder',
})
export class ChecklistItemOrderPipe implements PipeTransform {
  transform(
    value: ChecklistItem[],
    order: 'asc' | 'desc' = 'asc'
  ): ChecklistItem[] {
    return [...value].sort((a, b) => {
      if (order === 'asc') {
        return a.position - b.position;
      } else if (order === 'desc') {
        return b.position - a.position;
      }
      return 0;
    });
  }
}
